import React from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

function Faq({ children }) {
  return <dl>{children}</dl>;
}

function FaqItem({ question, answer }) {
  return (
    <Disclosure as="div" key={question} className="border-b py-4 border-gray-200">
      {({ open }) => (
        <>
          <dt className="text-lg">
            <DisclosureButton className="flex w-full items-start justify-between text-left">
              <span className="font-medium text-lg">{question}</span>
              <span className="ml-6 flex h-7 items-center">
                <ChevronDownIcon
                  className={clsx(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform')}
                  aria-hidden="true"
                />
              </span>
            </DisclosureButton>
          </dt>

          <DisclosurePanel as="dd" className="mt-4 text-base prose max-w-screen-md text-black">
            {typeof answer === 'string' ? (
              <div dangerouslySetInnerHTML={{ __html: answer }}></div>
            ) : (
              answer
            )}
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
}

Faq.Item = FaqItem;

export default Faq;
